import { jsx } from 'react/jsx-runtime';
import { ChevronLeftIcon, ChevronRightIcon } from '@flex-design-system/legacy-flex-icons';
import { styled } from '@flex-design-system/stitches-react';
import { IconButton } from '../../../button/icon-button/IconButton.mjs';
import { Flex } from '../../../layout/Flex.mjs';
import { Typography } from '../../../typography/Typography.mjs';

function CalendarHeader({ children, ...props }) {
  return /* @__PURE__ */ jsx(StyledCalendarHeader, { align: "center", justify: "between", ...props, children });
}
const StyledCalendarHeader = styled(Flex, {
  position: "relative",
  marginBottom: 10,
  gap: 8
});
function CalendarHeaderDateText({
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx(Typography, { css: { px: 8, py: 5 }, weight: 600, color: "grayDark", ...props, children });
}
function CalendarHeaderLeftSlot({ children }) {
  return /* @__PURE__ */ jsx(Flex, { align: "center", children });
}
function CalendarHeaderRightSlot({ children }) {
  return /* @__PURE__ */ jsx(Flex, { align: "center", children });
}
function CalendarHeaderPrevIconButton(props) {
  return /* @__PURE__ */ jsx(
    StyledIconButton,
    {
      size: "small",
      variant: "ghost",
      icon: /* @__PURE__ */ jsx(StyledLeftIcon, { color: "grayLight" }),
      ...props
    }
  );
}
function CalendarHeaderNextIconButton(props) {
  return /* @__PURE__ */ jsx(
    StyledIconButton,
    {
      size: "small",
      variant: "ghost",
      icon: /* @__PURE__ */ jsx(StyledRightIcon, { color: "grayLight" }),
      ...props
    }
  );
}
const StyledLeftIcon = styled(ChevronLeftIcon);
const StyledRightIcon = styled(ChevronRightIcon);
const StyledIconButton = styled(IconButton, {
  "&&": {
    padding: 0,
    width: 24,
    height: 24,
    borderRadius: 4,
    "&:hover, &:focus-visible": {
      [`${StyledLeftIcon}, ${StyledRightIcon}`]: {
        path: {
          fill: "$gray"
        }
      }
    }
  }
});
CalendarHeader.DateText = CalendarHeaderDateText;
CalendarHeader.LeftSlot = CalendarHeaderLeftSlot;
CalendarHeader.RightSlot = CalendarHeaderRightSlot;
CalendarHeader.PrevIconButton = CalendarHeaderPrevIconButton;
CalendarHeader.NextIconButton = CalendarHeaderNextIconButton;

export { CalendarHeader as default };
//# sourceMappingURL=CalendarHeader.mjs.map
